import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { Policy } from '@wsphere/warranties/domain';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-email-preview-dialog',
  templateUrl: './email-preview.dialog.html',
  standalone: false,
})
export class EmailPreviewDialog {
  private readonly cdr = inject(ChangeDetectorRef);

  @ViewChild(DialogComponent) dialog?: DialogComponent;
  protected email: Policy.Email | null = null;
  protected emailButton: string | null = null;
  protected previewFormat: 'html' | 'text' = 'html';

  private readonly emailButtons = new Map<Policy.EmailType, string>([
    [Policy.EmailType.warrantyProvisioned, 'Web Portal'],
    [Policy.EmailType.warrantyRenewal, 'Web Portal'],
    [Policy.EmailType.loginLink, 'Continue to Portal'],
    [Policy.EmailType.claimCreated, 'Your Claim'],
    [Policy.EmailType.claimClosed, 'Your Claim'],
    [Policy.EmailType.claimPaymentIssued, 'Your Claim'],
    [Policy.EmailType.claimDocumentUploaded, 'Your Claim'],
  ]);

  open(email: Policy.Email) {
    this.email = email;
    this.emailButton = this.emailButtons.get(email.type) ?? null;
    this.previewFormat = 'html';
    this.dialog?.open();
    // Dialog.open() only flushes the overlay view; refresh this host so projected
    // title/subject/body bind in the same turn (otherwise they wait for a later CD).
    this.cdr.detectChanges();
  }

  protected setPreviewFormat(value: unknown) {
    if (value === 'html' || value === 'text') this.previewFormat = value;
  }
}
